import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mux = defineConnector({
  identifier: "mux",
  name: "Mux",
  tagLine: "Video streaming and analytics APIs",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.mux\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.tokenId,
      password: app.secret.tokenSecret,
    }),
  steps: [
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Mux dashboard](https://dashboard.mux.com/settings/access-tokens), open **Settings › Access Tokens** and generate a token. Copy the token ID and secret — the secret is only shown once.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Token ID",
          required: true,
          target: { kind: "secrets", field: "tokenId" },
        },
        {
          kind: "input",
          label: "Token secret",
          required: true,
          target: { kind: "secrets", field: "tokenSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.mux.com/video/v1/assets?limit=1",
  },
});
